import React from "react";
import { Link } from "react-router-dom";
import { Phone, ClipboardText } from "@phosphor-icons/react";

export default function MobileActionBar() {
  return (
    <div
      data-testid="mobile-action-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-chrome bg-obsidian/95 backdrop-blur-xl"
    >
      <a
        data-testid="mobile-action-call"
        href="tel:7029290390"
        className="flex items-center justify-center gap-2 py-4 text-white font-bold uppercase tracking-wider text-sm border-r border-chrome"
      >
        <Phone size={18} weight="fill" className="text-solar" />
        Call
      </a>
      <Link
        data-testid="mobile-action-quote"
        to="/request-a-quote"
        className="flex items-center justify-center gap-2 py-4 bg-solar text-black font-bold uppercase tracking-wider text-sm"
      >
        <ClipboardText size={18} weight="fill" />
        Get Quote
      </Link>
    </div>
  );
}
